var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.BookingInfor,{attrs:{"booking-info":_setup.bookingInfo}}),_c('p',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_setup.transferBookingText)+" ")]),_c(_setup.UserList,{ref:"selectCoachList",attrs:{"enable-search":true,"user-list":_setup.coachList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }